import type { FaireProductEntity } from "../../entity_types/product";

export const p_abkkzv5z3b: FaireProductEntity = {
  token: "p_abkkzv5z3b",
  type: "product",
  name: "Adjustable stainless steel band ring universe",
  brandToken: "b_bar2elb7rv",
  brandName: "SHINE BUY",
  imageUrl:
    "https://cdn.faire.com/fastly/5722cb9569e0acdf368904e17cd017eeb71d294ebb03faa6d80e0b904149bcce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1ce3059b3c0ac8d8ce184ad91c13929f98c209a6001055f22142d911a5745f0.jpeg",
    "https://cdn.faire.com/fastly/c0ed5b7851cf64e6f500b5c1aba8b67531c9a8cc020fb36d6813be3a2bb0680b.jpeg",
    "https://cdn.faire.com/fastly/19f79cff1982a0c924939f4e16058ce3d2e6c322f65a65451fd6d09492a2c7c6.jpeg",
  ],
  priceDollars: 3.55,
  description:
    "Adjustable stainless steel band ring universe  &lt;p&gt;Adjustable stainless steel ring in gold and in silver color.&lt;/p&gt;\r\n&lt;p&gt;Size: One Size&lt;/p&gt;",
  tags: [],
  msrpDollars: 14.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:22.175Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
